import { render } from "./sglm-trustees.vue?vue&type=template&id=58bc15f1&scoped=true"
import script from "./sglm-trustees.vue?vue&type=script&lang=js"
export * from "./sglm-trustees.vue?vue&type=script&lang=js"

import "./sglm-trustees.vue?vue&type=style&index=0&id=58bc15f1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58bc15f1"]])

export default __exports__